import { useSelector } from "react-redux";
import { menuState } from "../../../redux/slices/menuSlice";

const MainMenuData = (data) => {
  const menuData = useSelector(menuState);
  return <div></div>;
};

export default MainMenuData;
